import type { AkimaConfig, AkimaSubmitOptions, AkimaResult } from "./types";
import { renderForm } from "./form";
import { submitAssessment } from "./api";

// Double-load guard
if (
  typeof window !== "undefined" &&
  (window as unknown as Record<string, unknown>).__AKIMA_SDK_LOADED__
) {
  console.warn("[AkimaSDK] SDK already loaded. Skipping re-initialization.");
}

if (typeof window !== "undefined") {
  (window as unknown as Record<string, unknown>).__AKIMA_SDK_LOADED__ = true;
}

export const version = "1.0.0";

export function init(config: AkimaConfig): void {
  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", () => renderForm(config));
  } else {
    renderForm(config);
  }
}

export function submit(options: AkimaSubmitOptions): Promise<AkimaResult> {
  return submitAssessment(options);
}
